var KeyCodes = /*#__PURE__*/function (KeyCodes) {
  KeyCodes[KeyCodes["ENTER"] = 13] = "ENTER";
  KeyCodes[KeyCodes["ESCAPE"] = 27] = "ESCAPE";
  KeyCodes[KeyCodes["TAB"] = 9] = "TAB";
  return KeyCodes;
}({});
var KeyBoardKeys = /*#__PURE__*/function (KeyBoardKeys) {
  KeyBoardKeys["ENTER"] = "Enter";
  KeyBoardKeys["SPACE"] = " ";
  return KeyBoardKeys;
}({});

export { KeyBoardKeys, KeyCodes };
